"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleBar = void 0;
const core_1 = require("@material-ui/core");
const icon_button_1 = require("client/components/material/icon-button");
const menu_1 = require("client/components/material/menu");
const select_1 = require("client/components/material/select");
const router_1 = require("client/components/router");
const sidebar_1 = require("client/components/sidebar/sidebar");
const store_1 = require("client/modules/app-settings/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/store/store");
const store_4 = require("client/modules/users/store");
const Menu_1 = require("material-ui-icons/Menu");
const AppBar_1 = require("material-ui/AppBar");
const Menu_2 = require("material-ui/Menu");
const Toolbar_1 = require("material-ui/Toolbar");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const app_settings_1 = require("shared/app-settings");
require("./title-bar.less");
const logo = require("client/resources/imb-logo.svg");
let TitleBar = class TitleBar extends react_1.Component {
    constructor() {
        super(...arguments);
        this.printLabelsPage = false;
        this.isDev = false;
        this.stuff = [
            {
                id: 4,
                label: "Dev",
                value: "4"
            },
            {
                id: 1,
                label: "Admin",
                value: "1"
            },
            {
                id: 2,
                label: "Manager",
                value: "2"
            },
            {
                id: 3,
                label: "User",
                value: "3"
            },
            {
                id: 5,
                label: "Clinic Admin",
                value: "5"
            },
            {
                id: 6,
                label: "Clinic Manager",
                value: "6"
            },
            {
                id: 7,
                label: "Clinic User",
                value: "7"
            },
            {
                id: 9,
                label: "Clinic Provider",
                value: "9"
            },
            {
                id: 10,
                label: "Distributor Admin",
                value: "10"
            },
            {
                id: 11,
                label: "Distributor Manager",
                value: "11"
            },
            {
                id: 12,
                label: "Distributor User",
                value: "12"
            },
        ];
        // E-050
        this.managerRole = [
            {
                id: 2,
                label: "Manager",
                value: "2"
            },
            {
                id: 5,
                label: "Clinic Admin",
                value: "5"
            },
            {
                id: 6,
                label: "Clinic Manager",
                value: "6"
            },
            {
                id: 7,
                label: "Clinic User",
                value: "7"
            },
            {
                id: 9,
                label: "Clinic Provider",
                value: "9"
            }
        ];
        this.handleChangeGroup = async (id) => {
            const test = await store_4.usersStore.updateGroup(Number(id));
            if (test)
                window.location.reload();
        };
        this.handleChangeSite = async (id) => {
            const test = await store_4.usersStore.updateSite(Number(id));
            if (test)
                window.location.reload();
        };
        this.deactivateOnPrintLabels = () => {
            const url = window.location.pathname;
            const urlArray = url.split("/");
            if (urlArray.includes("print-labels")) {
                this.printLabelsPage = true;
            }
        };
        this.onClickAvatar = (event) => {
            this.avatarOpen = event.currentTarget;
        };
        this.onClickAvatarItem = (index) => {
            switch (index) {
                case 0:
                    this.props.user &&
                        router_1.RouteManager.transitionTo(`/users/${this.props.user.id}`);
                    break;
                case 1:
                    localStorage.removeItem("order");
                    localStorage.removeItem("property");
                    store_4.usersStore.setToken("");
                    break;
            }
            this.avatarOpen = undefined;
        };
        this.onCloseAvatar = () => {
            this.avatarOpen = undefined;
        };
        this.onNavigate = (path) => () => {
            router_1.RouteManager.transitionTo(path);
        };
        this.toggleSidebar = () => {
            store_3.generalStore.menuOpen = !store_3.generalStore.menuOpen;
        };
        this.hoverOver = (event) => {
            const ele = event.target;
            ele.style.backgroundColor = "white";
            ele.style.color = "black";
        };
        this.hoverOut = (event) => {
            const ele = event.target;
            ele.style.backgroundColor = "#192e5b";
            ele.style.color = "white";
        };
        // public displayGroup = () => { 2024-04-30 21:57:56
        //   const canView = usersStore.user.value.modifyGroup || this.isDev;
        //   return canView ? (
        //     <MaterialSelect
        //       options={this.stuff}
        //       required
        //       searchable
        //       label="View as User Group"
        //       onSelect={this.handleChangeGroup}
        //       value={String(usersStore.user.value.groupId) || ""}
        //     />
        //   ) : (
        //     <></>
        //   );
        // };
        this.displayGroup = () => {
            // E-050
            const isManagerRole = store_4.usersStore.user.value.originalGroupId == 2;
            // console.log("usersStore.permissions", usersStore.permissions);
            const canView = store_4.usersStore.user.value.modifyGroup || this.isDev;
            // let viewGoupSelection = true
            let viewGoupSelection = store_4.usersStore.originalPermissions.ViewGroupSelection; // pharmacies | View disabled sites (sites list). // E-050 2024-04-30 21:55:15
            // return canView ? (
            return viewGoupSelection ? (React.createElement(select_1.MaterialSelect, { options: isManagerRole ? this.managerRole : store_4.usersStore.user.value.originalGroupId == 4 ? this.stuff : this.stuff.filter((item) => item.id >= store_4.usersStore.user.value.originalGroupId && item.id !== 4), required: true, searchable: true, label: "View as User Group", onSelect: this.handleChangeGroup, value: String(store_4.usersStore.user.value.groupId) || "" })) : ("");
        };
        // D-011 UpdateTitleSite will the part of user permission, If user don't know the permission it will not reflect here
        this.displaySite = () => store_4.usersStore.permissions.UpdateTitleSite === true &&
            (this.availableOptions.length > 1 ? (React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, searchable: true, label: "Browsing as Pharmacy", onSelect: this.handleChangeSite, value: String(store_4.usersStore.user.value.siteId) || "" })) : (React.createElement(core_1.Typography, { className: "site-name", variant: "subheading" }, store_4.usersStore.user.value.site.name)));
    }
    get availableOptions() {
        const user = store_4.usersStore.user.value || null;
        const showAllSites = store_4.usersStore.permissions.ReadPharmacies;
        if (!store_2.sitesListStore.sites.value) {
            return {
                id: 0,
                label: 'Fake',
                value: '0'
            };
        }
        return store_2.sitesListStore.sites.value
            .filter((site, i) => showAllSites ||
            site.id === user.site.id ||
            user.sites.includes(site.id))
            .map((site, i) => ({
            id: i,
            label: site.displayName || site.name,
            value: site.id.toString()
        }));
    }
    async componentDidMount() {
        await store_2.sitesListStore.loadSitesNoRelation();
        this.deactivateOnPrintLabels();
        const devCSV = await store_1.appSettingsStore.readSettings(app_settings_1.AppOption.Developers);
        const devs = devCSV ? devCSV.value.replace(/[^\d,]/g, "").split(",") : [];
        this.isDev = devs.includes(store_4.usersStore.user.value.id.toString());
        if (this.isDev) {
            this.stuff.push({
                id: 8,
                label: "Developer",
                value: "4"
            });
        }
    }
    render() {
        const { position = "fixed" } = this.props;
        const name = store_4.usersStore.user.value &&
            `${store_4.usersStore.user.value.firstName} ${store_4.usersStore.user.value.lastName}`.trim();
        const email = store_4.usersStore.user.value && store_4.usersStore.user.value.email;
        const displayName = name ? name : email;
        const siteName = store_4.usersStore.user.value.site
            ? store_4.usersStore.user.value.site.name
            : null;
        const claims = location.pathname.indexOf("claims") > -1;
        const printLabels = location.pathname.indexOf("print-labels") > -1;
        const hideUI = claims && printLabels;
        const showSiteDropdown = store_4.usersStore.user.value && store_4.usersStore.user.value.site;
        if (hideUI) {
            store_3.generalStore.setMenuOpen(false);
        }
        return (React.createElement("div", { className: "app-container" },
            React.createElement(AppBar_1.default, { className: "title-bar", position: position },
                React.createElement(Toolbar_1.default, null,
                    !hideUI && (React.createElement(icon_button_1.MaterialIconButton, { onClick: this.toggleSidebar },
                        React.createElement(Menu_1.default, null))),
                    React.createElement("div", { className: "title-bar__logo" }),
                    React.createElement("div", { className: "title-bar__submit" },
                        this.displayGroup(),
                        showSiteDropdown ? this.displaySite() : "",
                        React.createElement("a", { onClick: this.onClickAvatar, style: { paddingRight: "2em" } }, displayName))),
                React.createElement(menu_1.MaterialMenu, { open: Boolean(this.avatarOpen), onClose: this.onCloseAvatar, anchorEl: this.avatarOpen },
                    store_4.usersStore.permissions.ReadUsers && (React.createElement(Menu_2.MenuItem, { onClick: () => this.onClickAvatarItem(0) }, "Edit Profile")),
                    React.createElement(Menu_2.MenuItem, { onClick: () => this.onClickAvatarItem(1) }, "Close App"))),
            React.createElement(sidebar_1.Sidebar, null)));
    }
};
__decorate([
    mobx_1.observable
], TitleBar.prototype, "avatarOpen", void 0);
__decorate([
    mobx_1.observable
], TitleBar.prototype, "printLabelsPage", void 0);
__decorate([
    mobx_1.observable
], TitleBar.prototype, "isDev", void 0);
__decorate([
    mobx_1.computed
], TitleBar.prototype, "availableOptions", null);
TitleBar = __decorate([
    mobx_react_1.observer
], TitleBar);
exports.TitleBar = TitleBar;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/title-bar/title-bar.tsx
// module id = 3154
// module chunks = 0